"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Component, Ref, Vue } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
import _ from "lodash";
import Collector from "@/components/dialog/Collector.vue";
let DistributionDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialogVisible = false;
    this.collectorData = [];
    this.selecterVisible = true;
    this.disableBtn = false;
    this.disablebtn = false;
    this.opt_span_1 = 12;
    this.opt_span_2 = 12;
  }
  created() {
  }
  mounted() {
  }
  computed() {
    disablebtn:
      () => {
        if (this.disableBtn) {
          return false;
        }
        return this.collectorData.length < 1;
      };
    opt_span_1:
      () => {
        return this.opt_span_1;
      };
    opt_span_2:
      () => {
        return this.opt_span_2;
      };
  }
  setSelecterVisible(visible) {
    this.selecterVisible = visible;
  }
  setBtn(flag = false) {
    this.disableBtn = flag;
  }
  setOptSpan(span_1, span_2) {
    this.opt_span_1 = span_1;
    this.opt_span_2 = span_2;
  }
  add(itme) {
    this._collector.add(itme);
  }
  del(itme) {
    this._collector.del(itme);
  }
  changed(data) {
    this.collectorData = data;
    this.$emit("changed", data);
  }
  getAll() {
    if (this._collector && this._collector !== void 0) {
      return this._collector.getAll();
    } else {
      return [];
    }
  }
  getAllNew() {
    if (this._collector && this._collector !== void 0) {
      return this._collector.getAllNew();
    } else {
      return [];
    }
  }
  clear() {
    if (this._collector && this._collector !== void 0) {
      this._collector.clear();
    }
  }
  save() {
    if (this._collector && this._collector !== void 0) {
      this.$emit("saved", this._collector.getAll());
    } else {
      this.$emit("saved", []);
    }
  }
  syncData(allData, selectData, idName = "id", labelName = "name") {
    let unSelectData = _.differenceWith(allData, selectData, _.isEqual);
    for (const item of selectData) {
      const _item = {
        id: item[idName],
        label: item[labelName]
      };
      this._collector.add(_item);
    }
    for (const item of unSelectData) {
      const _item = {
        id: item[idName],
        label: item[labelName]
      };
      this._collector.del(_item);
    }
  }
  open() {
    this.dialogVisible = true;
    this.$nextTick(() => {
      this._collector.clear();
    });
  }
  close() {
    this.dialogVisible = false;
    this.$emit("refresh");
  }
  refresh() {
  }
};
__decorateClass([
  Ref("collector")
], DistributionDialog.prototype, "_collector", 2);
DistributionDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      Collector
    }
  })
], DistributionDialog);
export {
  DistributionDialog as default
};
